import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class VendorDashboardService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }


  // GET SERVICES
  GetVendorDashboard(userId: String,appType:String) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIEstimation?UserId=${userId}&AppType=${appType}`, { headers: this.buildHeaders()});
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIEstimation?UserId=1`);
  }

  getFarmerDashboardDataForVendor(vendorMobile:String){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerDashboardDataForVendor?VendorMobile=` + vendorMobile, { headers: this.buildHeaders() });
  }

  getComponentMaster(){
    return this.http.get(environment.apiUrl + 'FarmerApplication/GetComponentMaster');
  }

  getAllMIVendors(ProgramId){
    return this.http.get(`${environment.apiUrl}FarmerApplication/GetAllMIvenders?ProgramId=${ProgramId}`);
  }

  getCategory(reqBody){
    console.log(reqBody, 'reqBodyreqBody')
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetCategoryMaster?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}`);
  }

  getComponent(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetComponentMaster?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}`);
  }

  getCMLNumber(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Department/GetComponentMasterCML?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}&CompId=${reqBody.CompId}`);
  }

  getSizeAndPrice(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetSizePriceMaster?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}&ComponentId=${reqBody.ComponentId}`);
  }

  getVendorMIEstimation(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimation?AppId=${reqBody.AppId}&VendorRegId=${reqBody.VendorRegId}&ProgId=${reqBody.ProgramId}`);
  }


  getCropMaster(){
    return this.http.get<any>(`${environment.apiUrl}LandDetails/GetCropMaster`);
  }

  getChallanForVendor(UserId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetChallanForVendor?UserId=${UserId}`);
  }
  
  //POST SERVICES
  postVendorMIEstimationDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}DashBoard/InsertVendorMIEstimationDetail`, reqBody);
  }

  getMaxSubsidyEstimate(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Vendor/getMaxSubsidyEstimate`, reqBody);
  }

  insertChallanAcknowledgement(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertChallanAcknowledgement`, reqBody);
  }

  updateCMLValidity(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateCMLValidity`, reqBody);
  }

  // DELETE SERVICE
  deleteEstimation(reqBody){
    // AppId=1&VendorId=1&ProgId=1
    return this.http.delete<any>(`${environment.apiUrl}DashBoard/DeleteVendorMIEstimation?AppId=${reqBody.AppId}&VendorId=${reqBody.VendorRegId}&ProgId=${reqBody.ProgramId}`);
  }

  //UPDATE SERVICES
  updateVendorEstimationDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}DashBoard/UpdateVendorMIEstimation`, reqBody);
  }

  GetPreEstimationSurvey(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationsForMIPreEstimation?UserId=` + userId, { headers: this.buildHeaders() });
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIEstimation?UserId=1`);
  }

  GetEditPreEstimationSurvey(reqBody):any{
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetApplicationDataOfPreEstimation?AppId=${reqBody.AppId}&ProgId=${reqBody.ProgramId}`, { headers: this.buildHeaders() });
  }
  insertVendorInventoryDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertInventoryPurchaseDetail`, reqBody);
  }
  
  insertUploadedGSTDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertUploadedGSTDetail`, reqBody);
  }

  getInventoryPurchaseDetail(userId){
    return this.http.get(`${environment.apiUrl}Vendor/GetInventoryPurchaseDetail?UserId=${userId}`);
  }

  deleteInventoryPurchaseDetail(reqBody){
    return this.http.delete<any>(`${environment.apiUrl}Vendor/DeleteInventoryPurchaseDetail?autoId=${reqBody.autoId}&userID=${reqBody.userID}&network_Id=${reqBody.network_Id}&terminal_Id=${reqBody.terminal_Id}`);
  }

  updateInventoryPurchaseDetail(reqBody:any){
    return this.http.put<any>(`${environment.apiUrl}Vendor/UpdateInventoryPurchaseDetail`, reqBody);
  }

}
